import React from 'react';
import { getPrincipaleOPrimoMacroGruppo } from '../../data/utils';
import AggsContainer from './AggsContainer';
import MacrosContainer from './MacrosContainer';

function PrematchBetGroupsNew(props) {
    let macrogruppo = props.macrogruppo;
    if (props.macrogruppi.length > 0 && macrogruppo == null) {
        macrogruppo = getPrincipaleOPrimoMacroGruppo(props.macrogruppi);
    }
    const gruppiScommessa = macrogruppo != null ? macrogruppo.aggregate : props.aggregate;

    if (props.macrogruppi.length <= 1 && gruppiScommessa.length <= 1) {
        return null;
    }

    return (
        <div className="macro-gruppi mb-2">
            {props.macrogruppi.length > 1 &&
                <MacrosContainer current={macrogruppo.id} macros={props.macrogruppi} onClick={props.changeMacrogruppo} />
            }
            {gruppiScommessa.length > 1 &&
                <AggsContainer current={props.aggregata} aggs={gruppiScommessa} onClick={props.changeAggregata} />
            }
        </div>
    );
}

export default PrematchBetGroupsNew;